module.exports = __webpack_public_path__ + "static/messenger-9f3f25587fa11693eeeed81653ceaf69.png";